import React, { useState } from "react";
import {
  Card,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import SearchList from "./SearchList";
import { Href } from "../../../../../Utils/Constants";
import ChatTabPane from "./ChatTabPane";
import ContactsTabPane from "./GroupsTabPane";
import FriendsTabPane from "./FriendsTabPane";
import StoresTabPane from "./StoresTabPane";
import BlockTabPane from "./BlockTabPane";
import RequestsTab from "./RequestsTab";

export default function LeftSidebarChat() {
  const [activeTab, setActiveTab] = useState(1);
  return (
    <Col xxl={3} xl={4} md={5} className="box-col-5">
      <Card className="left-sidebar-wrapper">
        <SearchList />
        <div className="advance-options">
          <Nav className="border-tab over overflow-auto max-w-full flex-nowrap custom-scrollbar">
            <NavItem>
              <NavLink
                style={{ paddingLeft: "4px", paddingRight: "4px" }}
                href={Href}
                className={activeTab === 1 ? "active" : ""}
                onClick={() => setActiveTab(1)}
              >
                {"Chats"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href={Href}
                style={{ paddingLeft: "4px", paddingRight: "4px" }}
                className={activeTab === 2 ? "active" : ""}
                onClick={() => setActiveTab(2)}
              >
                {"Groups"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href={Href}
                style={{ paddingLeft: "4px", paddingRight: "4px" }}
                className={activeTab === 3 ? "active" : ""}
                onClick={() => setActiveTab(3)}
              >
                {"Friends"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href={Href}
                style={{ paddingLeft: "4px", paddingRight: "4px" }}
                className={activeTab === 4 ? "active" : ""}
                onClick={() => setActiveTab(4)}
              >
                {"Store"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href={Href}
                style={{ paddingLeft: "4px", paddingRight: "4px" }}
                className={activeTab === 5 ? "active" : ""}
                onClick={() => setActiveTab(5)}
              >
                {"Block"}
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ paddingLeft: "4px", paddingRight: "4px" }}
                href={Href}
                className={activeTab === 6 ? "active" : ""}
                onClick={() => setActiveTab(6)}
              >
                {"Requests"}
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId={1}>
              <ChatTabPane />
            </TabPane>
            <TabPane tabId={2}>
              <ContactsTabPane />
            </TabPane>
            <TabPane tabId={3}>
              <FriendsTabPane changeToChat={() => setActiveTab(1)} />
            </TabPane>
            <TabPane tabId={4}>
              <StoresTabPane />
            </TabPane>
            <TabPane tabId={5}>
              <BlockTabPane />
            </TabPane>
            <TabPane tabId={6}>
              <RequestsTab changeToChat={() => setActiveTab(1)} />
            </TabPane>
          </TabContent>
        </div>
      </Card>
    </Col>
  );
}
